import React from "react";
// TODO: Add react-helmet-async when React 19 support is available for SEO meta tags

import { useAuth } from "../contexts/AuthContext";
import StoreBanner from "../components/store-banner";
import "./LegalPages.css";

// Import existing assets
import logoImage from "../assets/dance_locale_3-200h.png";

const TermsConditions = () => {
    const { user, logout } = useAuth();

    const handleLogout = () => {
        logout();
    };

    return (
        <div className="legal-page">
                        {/* TODO: Add SEO meta tags when react-helmet-async supports React 19
                Title: "Terms and Conditions - Dance Locale" */}

            {/* Header using the same structure as other pages */}
            <div data-role="Header" className="home-header-container">
                <header className="home-header">
                    <a href="/" className="home-logo1">
                        <img alt="logo" src={logoImage} className="home-image1" />
                        <span className="nav-wordmark">Dance Localé</span>
                    </a>
                    <div className="home-menu1">
                        <a href="/" className="home-text10" style={{ cursor: "pointer", textDecoration: "none" }}>
                            Home
                        </a>
                        {user ? (
                            <>
                                {user.organisationId && (
                                    <a
                                        href="/dashboard"
                                        className="home-text12"
                                        style={{ cursor: "pointer", textDecoration: "none" }}>
                                        Dashboard
                                    </a>
                                )}
                                <a
                                    href="/my-hub"
                                    className="home-text12"
                                    style={{ cursor: "pointer", textDecoration: "none" }}>
                                    My Hub
                                </a>
                                <button onClick={handleLogout} className="home-text13" style={{ cursor: "pointer" }}>
                                    Logout
                                </button>
                            </>
                        ) : (
                            <>
                                <a
                                    href="/login"
                                    className="home-text12"
                                    style={{ cursor: "pointer", textDecoration: "none" }}>
                                    Login
                                </a>
                                <a href="/contact" className="home-text13" style={{ textDecoration: "none" }}>Contact</a>
                            </>
                        )}
                    </div>
                    <div className="home-container11">
                        <StoreBanner />
                    </div>
                </header>
            </div>

            {/* Main content using AdminConsole structure */}
            <div className="dashboard-main">
                <div className="dashboard-content-wrapper">
                    <div className="dashboard-header-card">
                        <h1 className="admin-console-title">Terms and Conditions</h1>
                        <p className="admin-console-description">
                            Last updated: 28 September 2026. These terms govern your use of the Dance Localé platform and
                            services.
                        </p>

                        {/* 1.0 Acceptance of Terms */}
                        <div className="legal-section">
                            <h2 className="legal-section-title">1.0 Acceptance of Terms</h2>

                            <p className="legal-clause">
                                <span className="legal-clause-num">1.1</span>
                                By accessing or using the Dance Localé application and services, you agree to be bound
                                by these Terms and Conditions. If you do not agree to these terms, please do not use our
                                services.
                            </p>
                            <p className="legal-clause">
                                <span className="legal-clause-num">1.2</span>
                                <strong>Definitions.</strong> In these Terms, <strong>"Supplier"</strong> means a dance
                                school, dance instructor, or event organiser who lists, sells, or accepts payment for
                                classes, lessons, enrolments, bookings, or event tickets through Dance Localé.{" "}
                                <strong>"Dance Localé"</strong>, <strong>"we"</strong>, and <strong>"us"</strong> mean
                                Yadawn Pty Ltd (ABN 59 010 557 543) trading as Dance Locale. <strong>"Buyer"</strong>{" "}
                                means a student, attendee, or other person who purchases or books a Supplier's services
                                or tickets through the platform.
                            </p>
                        </div>

                        {/* 2.0 Our Role as a Marketplace */}
                        <div className="legal-section">
                            <h2 className="legal-section-title">2.0 Our Role as a Marketplace</h2>

                            <p className="legal-clause">
                                <span className="legal-clause-num">2.1</span>
                                <strong>Marketplace and Supplier of Record.</strong> Dance Localé operates an online
                                marketplace that allows Suppliers to promote, sell, and collect payment for their
                                classes, lessons, enrolments, bookings, and event tickets. Dance Localé is not the
                                supplier or seller of any class, lesson, enrolment, booking, or event ticket offered
                                through the platform. The contract for those services is formed directly between the
                                Buyer and the relevant Supplier, and the Supplier is the supplier of record for that
                                transaction.
                            </p>
                            <p className="legal-clause">
                                <span className="legal-clause-num">2.2</span>
                                <strong>Limited Payment Collection Agent.</strong> For each transaction, the Supplier
                                appoints Dance Localé as its limited payment collection agent for the sole purpose of
                                collecting payment from the Buyer on the Supplier's behalf. When a Buyer pays for a
                                Supplier's service or ticket through the platform, that payment is treated as having been
                                made by the Buyer directly to the Supplier, and the Supplier's obligation to the Buyer is
                                satisfied to the extent of that payment. Acceptance of a payment by Dance Localé as
                                limited payment collection agent does not make Dance Localé a party to the contract
                                between the Buyer and the Supplier.
                            </p>
                        </div>

                        {/* 3.0 Use of Service */}
                        <div className="legal-section">
                            <h2 className="legal-section-title">3.0 Use of Service</h2>

                            <p className="legal-clause">
                                <span className="legal-clause-num">3.1</span>
                                <strong>General Use.</strong> Dance Localé provides event discovery, ticketing, dance
                                class management, and instructor booking services. By using our platform, you agree to
                                use these services responsibly and in accordance with these terms and all applicable
                                laws.
                            </p>
                            <p className="legal-clause">
                                <span className="legal-clause-num">3.2</span>
                                <strong>License to Use.</strong> By submitting content, you grant us a license to use,
                                display, and distribute your content on our platform.
                            </p>
                            <p className="legal-clause">
                                <span className="legal-clause-num">3.3</span>
                                <strong>Content Responsibility.</strong> You are responsible for ensuring your content
                                does not violate any laws or third-party rights.
                            </p>
                            <p className="legal-clause">
                                <span className="legal-clause-num">3.4</span>
                                <strong>Profile Photos and Account Images.</strong> By uploading a profile photo or other
                                image to your Dance Localé account, you confirm that you have the right to use that image
                                and grant Dance Localé a licence to display it within the platform. Your account profile
                                photo may be shown to dance schools you enrol with so their staff can identify you at
                                class check-in.
                            </p>
                            <p className="legal-clause">
                                <span className="legal-clause-num">3.5</span>
                                <strong>School-Uploaded Student Photos.</strong> Dance schools that use the class
                                management features of Dance Localé may upload identification photos for their enrolled
                                students. By uploading a student photo, the school agrees that:
                            </p>
                            <p className="legal-clause legal-clause-deep">
                                <span className="legal-clause-num legal-clause-num-deep">3.5.1</span>
                                <strong>Consent.</strong> The school has obtained any consent required under applicable
                                privacy laws to photograph and store an identification image of the student.
                            </p>
                            <p className="legal-clause legal-clause-deep">
                                <span className="legal-clause-num legal-clause-num-deep">3.5.2</span>
                                <strong>Purpose limitation.</strong> Student photos are used solely for in-school
                                identification at class check-in and will not be shared publicly or used for any other
                                purpose.
                            </p>
                            <p className="legal-clause legal-clause-deep">
                                <span className="legal-clause-num legal-clause-num-deep">3.5.3</span>
                                <strong>Responsibility.</strong> The school is solely responsible for complying with
                                applicable privacy laws regarding the collection, storage, and use of student images.
                                Dance Localé provides storage infrastructure only and bears no liability for a school's
                                failure to obtain proper consent.
                            </p>
                            <p className="legal-clause legal-clause-deep">
                                <span className="legal-clause-num legal-clause-num-deep">3.5.4</span>
                                <strong>Removal.</strong> The school is responsible for removing a student photo on the
                                student's request and for not retaining it longer than needed for the student's
                                participation.
                            </p>
                            <p className="legal-clause">
                                <span className="legal-clause-num">3.6</span>
                                <strong>Our Content.</strong> All content provided by Dance Localé, including but not
                                limited to text, graphics, logos, and software, is the property of Dance Localé or its
                                licensors and is protected by intellectual property laws.
                            </p>
                        </div>

                        {/* 4.0 Event Organiser Responsibilities */}
                        <div className="legal-section">
                            <h2 className="legal-section-title">4.0 Event Organiser Responsibilities</h2>

                            <p className="legal-clause">
                                <span className="legal-clause-num">4.1</span>
                                <strong>Authorisation and Ownership.</strong> When you create an event or import event
                                data (including ICS calendar files) to sell tickets on Dance Localé, you represent and
                                warrant that:
                            </p>
                            <ul className="legal-list">
                                <li>You are the authorised event organiser or have explicit permission from the event organiser</li>
                                <li>You have the legal right to create and sell tickets for the event</li>
                                <li>All event information provided is accurate and not misleading</li>
                                <li>You will honour all tickets sold through the platform</li>
                            </ul>
                            <p className="legal-clause">
                                <span className="legal-clause-num">4.2</span>
                                <strong>Calendar Import (ICS Files).</strong> When importing events via ICS calendar
                                files, you confirm that you have authorisation to commercialise these events through
                                ticket sales. Dance Localé accepts your representation in good faith and does not
                                independently verify event ownership or authorisation.
                            </p>
                        </div>

                        {/* 5.0 Dance School Responsibilities */}
                        <div className="legal-section">
                            <h2 className="legal-section-title">5.0 Dance School Responsibilities</h2>

                            <p className="legal-clause legal-lead">
                                Dance schools using the class management, enrolment, and payment features of Dance Localé
                                agree that:
                            </p>
                            <p className="legal-clause">
                                <span className="legal-clause-num">5.1</span>
                                <strong>Accurate information.</strong> All class details, pricing, term dates, and
                                enrolment information provided to students through the platform are accurate and not
                                misleading.
                            </p>
                            <p className="legal-clause">
                                <span className="legal-clause-num">5.2</span>
                                <strong>Student management.</strong> The enrolment, attendance, and management of students
                                is the sole responsibility of the dance school. Dance Localé provides software tools only
                                and is not responsible for errors in student records where those errors arise from data
                                entered or managed by the school.
                            </p>
                            <p className="legal-clause">
                                <span className="legal-clause-num">5.3</span>
                                <strong>Payment amounts.</strong> All class fees, enrolment fees, and instalment amounts
                                are set and configured by the dance school. Dance Localé is not liable for overcharges or
                                undercharges to students where those errors result from amounts entered or pricing
                                settings configured by the school. Dance Localé remains responsible for errors caused by
                                defects in the platform itself.
                            </p>
                            <p className="legal-clause">
                                <span className="legal-clause-num">5.4</span>
                                <strong>Payment obligations.</strong> Schools are responsible for honouring all class
                                enrolments and instructor bookings for which payment has been collected through the
                                platform.
                            </p>
                            <p className="legal-clause">
                                <span className="legal-clause-num">5.5</span>
                                <strong>Refunds.</strong> Schools are responsible for managing their own refund policies
                                for class enrolments and instructor bookings. Dance Localé is not liable for refunds owed
                                by schools to students.
                            </p>
                            <p className="legal-clause">
                                <span className="legal-clause-num">5.6</span>
                                <strong>Student data.</strong> Schools are responsible for complying with applicable
                                privacy laws in relation to student information collected and managed through the
                                platform.
                            </p>
                        </div>

                        {/* 6.0 Ticketing and Liability */}
                        <div className="legal-section">
                            <h2 className="legal-section-title">6.0 Ticketing and Liability</h2>

                            <p className="legal-clause">
                                <span className="legal-clause-num">6.1</span>
                                <strong>Event Authenticity.</strong> Dance Localé acts as a platform connecting event
                                organisers with attendees. We do not independently verify the authenticity of events, the
                                authority of organisers to sell tickets, or the accuracy of event information provided by
                                organisers.
                            </p>
                            <p className="legal-clause">
                                <span className="legal-clause-num">6.2</span>
                                <strong>Limitation of Liability for False or Unauthorised Events.</strong> To the maximum
                                extent permitted by law, Dance Localé shall not be held liable for:
                            </p>
                            <ul className="legal-list">
                                <li>Tickets sold by unauthorised individuals or organisations</li>
                                <li>False, fraudulent, or misrepresented event information</li>
                                <li>Events that are cancelled, modified, or do not occur as advertised</li>
                                <li>Disputes between ticket purchasers and event organisers</li>
                                <li>Financial losses resulting from fraudulent ticket sales</li>
                            </ul>
                            <p className="legal-clause">
                                <span className="legal-clause-num">6.3</span>
                                <strong>Your Recourse.</strong> If you believe you have purchased a ticket from an
                                unauthorised organiser or for a fraudulent event, please contact us immediately at
                                support@dancelocale.com. We will investigate and take appropriate action, including
                                potentially removing the organiser from our platform. Financial resolution remains the
                                responsibility of the event organiser. See section 7.0 for how Dance Localé assists in
                                resolving disputes.
                            </p>
                        </div>

                        {/* 7.0 Disputes */}
                        <div className="legal-section">
                            <h2 className="legal-section-title">7.0 Disputes</h2>

                            <p className="legal-clause">
                                <span className="legal-clause-num">7.1</span>
                                Dance Localé provides a platform that connects dance schools, event organisers, and
                                instructors with students and attendees. Disputes arising from class enrolments,
                                instructor bookings, ticket purchases, or other transactions are primarily the
                                responsibility of the relevant school, organiser, or instructor.
                            </p>
                            <p className="legal-clause">
                                <span className="legal-clause-num">7.2</span>
                                Where a dispute is raised with Dance Localé, we will:
                            </p>
                            <p className="legal-clause legal-clause-deep">
                                <span className="legal-clause-num legal-clause-num-deep">7.2.1</span>
                                <strong>Provide transaction records.</strong> Make relevant transaction records available
                                to the parties involved upon request to assist in resolving the dispute.
                            </p>
                            <p className="legal-clause legal-clause-deep">
                                <span className="legal-clause-num legal-clause-num-deep">7.2.2</span>
                                <strong>Investigate platform issues.</strong> Investigate any reported defect in the Dance
                                Localé platform that may have contributed to the dispute, and take corrective action where
                                a platform error is identified.
                            </p>
                            <p className="legal-clause legal-clause-deep">
                                <span className="legal-clause-num legal-clause-num-deep">7.2.3</span>
                                <strong>Act on serious breaches.</strong> Take action against schools, organisers, or
                                instructors who are found to have breached these Terms, up to and including removal from
                                the platform.
                            </p>
                            <p className="legal-clause">
                                <span className="legal-clause-num">7.3</span>
                                Dance Localé is not liable for the outcome of any dispute arising from pricing set,
                                services delivered, or obligations owed by a dance school, event organiser, or instructor.
                                Nothing in this section limits any rights you may have under the Australian Consumer Law.
                            </p>
                        </div>

                        {/* 8.0 Payments and Fees */}
                        <div className="legal-section">
                            <h2 className="legal-section-title">8.0 Payments and Fees</h2>

                            <p className="legal-clause">
                                <span className="legal-clause-num">8.1</span>
                                <strong>Service Fee.</strong> A service fee is added to student payments made online
                                through Dance Localé, and is shown as a single line at checkout before the student pays.
                                This fee is charged to the student on top of the price set by the dance school,
                                instructor, or event organiser. It is made up of the 2.5% Dance Localé fee and an amount
                                to cover the cost of processing online payments. The service fee is the same whichever
                                online payment method the student uses.
                            </p>
                            <p className="legal-clause">
                                <span className="legal-clause-num">8.2</span>
                                Where the dance school, instructor, or event organiser has enabled this option, students
                                may instead pay them directly by bank transfer, outside the Dance Localé online checkout.
                                No online service fee applies to payments made directly in this way.
                            </p>
                            <p className="legal-clause">
                                <span className="legal-clause-num">8.3</span>
                                <strong>Payment Processing.</strong> Payments are processed by Stripe. Funds for a
                                Supplier's classes, lessons, enrolments, bookings, or tickets are collected through the Dance
                                Localé payment platform and routed to the Supplier's connected Stripe account, less the
                                service fee. Dance Localé retains only the 2.5% Dance Localé fee; the rest of the service
                                fee covers payment processing costs, and the remainder is the Supplier's revenue. Dance
                                Localé does not store
                                complete card details. The timing and availability of payouts to a Supplier's connected
                                account are determined by Stripe and by the Supplier completing Stripe onboarding and
                                verification.
                            </p>
                            <p className="legal-clause">
                                <span className="legal-clause-num">8.4</span>
                                <strong>Taxes and Tax Invoices.</strong> Each Supplier is solely responsible for
                                determining, collecting, reporting, and remitting any taxes (including GST, VAT, sales, or
                                similar taxes) that apply to the classes, lessons, enrolments, bookings, or tickets it
                                sells through the platform. Dance Localé does not provide tax advice and does not collect
                                or remit tax on a Supplier's sales.
                            </p>
                            <p className="legal-clause">
                                <span className="legal-clause-num">8.5</span>
                                Dance Localé charges and accounts for tax only on its own service fee. Any tax invoice
                                issued by Dance Localé covers the Dance Localé service fee only. Where a Buyer requires a
                                tax invoice for the class, lesson, enrolment, booking, or ticket itself, the Supplier is
                                responsible for issuing it. Receipts generated by the platform identify the Supplier as
                                the seller of that portion and direct tax invoice requests to the Supplier.
                            </p>
                            <p className="legal-clause">
                                <span className="legal-clause-num">8.6</span>
                                <strong>Refunds.</strong> Refund policies for class enrolments and instructor bookings are
                                set by the individual dance school or instructor. For event tickets, refund terms are
                                determined by the event organiser. Dance Localé does not guarantee refunds and is not
                                responsible for amounts owed by schools, instructors, or event organisers to students.
                            </p>
                            <p className="legal-clause">
                                <span className="legal-clause-num">8.7</span>
                                A Supplier's refund policy must, at a minimum, provide a refund or equivalent remedy where
                                a class, lesson, or event is cancelled, is not provided, or is materially different from
                                what was advertised. Nothing in a Supplier's published refund policy overrides a Buyer's
                                non-excludable rights under the Australian Consumer Law.
                            </p>
                            <p className="legal-clause">
                                <span className="legal-clause-num">8.8</span>
                                Payment processing fees charged by Stripe are non-refundable in the event of a
                                cancellation or refund.
                            </p>
                            <p className="legal-clause">
                                <span className="legal-clause-num">8.9</span>
                                <strong>Chargebacks.</strong> Dance Localé may recover from the Supplier any chargeback,
                                reversal, refund, or associated costs arising from the Supplier's transactions where Dance
                                Localé incurs those costs, including by setting those amounts off against funds otherwise
                                payable to the Supplier. Dance Localé will notify the Supplier of the dispute and, where
                                reasonably practicable, allow the Supplier an opportunity to provide evidence to contest
                                the chargeback.
                            </p>
                        </div>

                        {/* 9.0 Disclaimers and Limitations */}
                        <div className="legal-section">
                            <h2 className="legal-section-title">9.0 Disclaimers and Limitations</h2>

                            <p className="legal-clause">
                                <span className="legal-clause-num">9.1</span>
                                <strong>Service Availability.</strong> We provide our services on an "as is" and "as
                                available" basis. We do not guarantee that our services will be uninterrupted,
                                error-free, or completely secure. We reserve the right to modify, suspend, or discontinue
                                any aspect of the service at any time.
                            </p>
                            <p className="legal-clause">
                                <span className="legal-clause-num">9.2</span>
                                <strong>Event Information.</strong> Event information on our platform is provided by event
                                organisers. While we encourage accuracy, we are not responsible for any errors,
                                cancellations, or changes to events listed on our platform. Users should verify event
                                details directly with organisers when purchasing tickets.
                            </p>
                            <p className="legal-clause">
                                <span className="legal-clause-num">9.3</span>
                                <strong>Payment Processing.</strong> All payment transactions are processed securely
                                through Stripe. Dance Localé does not store complete card details. See section 8.0 for
                                full details on fees and refund terms.
                            </p>
                        </div>

                        {/* 10.0 Limitation of Liability */}
                        <div className="legal-section">
                            <h2 className="legal-section-title">10.0 Limitation of Liability</h2>

                            <p className="legal-clause">
                                <span className="legal-clause-num">10.1</span>
                                To the maximum extent permitted by law, Dance Localé and its officers, directors,
                                employees, and agents shall not be liable for any indirect, incidental, special,
                                consequential, or punitive damages, including but not limited to:
                            </p>
                            <ul className="legal-list">
                                <li>Loss of profits, data, or use</li>
                                <li>Loss of business opportunity or goodwill</li>
                                <li>Fraudulent ticket sales by event organisers</li>
                                <li>Unauthorised use of intellectual property by event organisers</li>
                                <li>Event cancellations, modifications, or no-shows</li>
                                <li>Disputes between ticket purchasers and event organisers</li>
                                <li>Any claims arising from your use of our services</li>
                            </ul>
                            <p className="legal-clause">
                                <span className="legal-clause-num">10.2</span>
                                In jurisdictions that do not allow the exclusion or limitation of liability for
                                consequential or incidental damages, our liability shall be limited to the maximum extent
                                permitted by law.
                            </p>
                        </div>

                        {/* 11.0 Termination */}
                        <div className="legal-section">
                            <h2 className="legal-section-title">11.0 Termination</h2>

                            <p className="legal-clause">
                                <span className="legal-clause-num">11.1</span>
                                We reserve the right to terminate or suspend your account and access to our services at
                                any time, without prior notice, for any reason, including breach of these Terms and
                                Conditions.
                            </p>
                        </div>

                        {/* 12.0 Changes to Terms */}
                        <div className="legal-section">
                            <h2 className="legal-section-title">12.0 Changes to Terms</h2>

                            <p className="legal-clause">
                                <span className="legal-clause-num">12.1</span>
                                We reserve the right to modify these Terms and Conditions at any time. We will notify
                                users of any material changes by posting the updated terms on our platform. Your continued
                                use of our services after any modifications constitutes acceptance of the updated terms.
                            </p>
                        </div>

                        {/* 13.0 Governing Law and Jurisdiction */}
                        <div className="legal-section">
                            <h2 className="legal-section-title">13.0 Governing Law and Jurisdiction</h2>

                            <p className="legal-clause">
                                <span className="legal-clause-num">13.1</span>
                                These Terms and Conditions shall be governed by and construed in accordance with the laws
                                of Australia, without regard to its conflict of law provisions. Any disputes arising out
                                of or relating to these terms shall be subject to the exclusive jurisdiction of the courts
                                of Australia.
                            </p>
                            <p className="legal-clause">
                                <span className="legal-clause-num">13.2</span>
                                These services are provided by Yadawn Pty Ltd (ABN 59 010 557 543) trading as Dance
                                Locale.
                            </p>
                        </div>

                        {/* 14.0 Contact Information */}
                        <div className="legal-section">
                            <h2 className="legal-section-title">14.0 Contact Information</h2>

                            <p className="legal-clause legal-lead">
                                If you have any questions about these Terms and Conditions, please contact us at:
                            </p>

                            <div style={{ textAlign: "center", marginTop: "1rem", marginBottom: "2rem" }}>
                                <a
                                    href="mailto:support@dancelocale.com?subject=Terms and Conditions Inquiry"
                                    style={{
                                        color: "var(--dl-color-purple-default)",
                                        fontSize: "1.1rem",
                                        fontWeight: "600",
                                        textDecoration: "none",
                                    }}>
                                    support@dancelocale.com
                                </a>
                            </div>

                            <div style={{ textAlign: "center", marginTop: "2rem" }}>
                                <StoreBanner />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TermsConditions;
